module.exports = __webpack_public_path__ + "img/pattern-crest.180626fc.svg";